var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.935,
    height: 43.023,
    viewBox: "0 0 34.935 43.023",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#2eb77d;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(648 -4434)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-648 4434)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M38.473,222.55a12.75,12.75,0,0,1,6.747-11.281h0a5.583,5.583,0,0,1,.83-.387A14.979,14.979,0,0,0,39.69,209.5h-4.2a15.329,15.329,0,0,0-15.373,15.318v3.871a1.629,1.629,0,0,0,1.659,1.659H41.128a9.4,9.4,0,0,1-.553-.774A12.484,12.484,0,0,1,38.473,222.55Z",
    transform: "translate(-20.114 -187.324)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M99.253,20.35a10.217,10.217,0,0,0,7.189-2.986,10.146,10.146,0,0,0,0-14.378,10.146,10.146,0,0,0-14.378,0,10.316,10.316,0,0,0-2.986,7.189A10.219,10.219,0,0,0,99.253,20.35Z",
    transform: "translate(-81.778 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M27.69,222.55a12.75,12.75,0,0,0-6.747-11.281h0a5.583,5.583,0,0,0-.83-.387,14.979,14.979,0,0,1,6.359-1.382h4.2A15.329,15.329,0,0,1,46.05,224.817v3.871a1.629,1.629,0,0,1-1.659,1.659H25.036a9.4,9.4,0,0,0,.553-.774A12.484,12.484,0,0,0,27.69,222.55Z",
    transform: "translate(-11.114 -187.324)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.5d5016429cfb2a8452fd4fbc35e4459c.svg";
export { ForwardRef as ReactComponent };